import { render, staticRenderFns } from "./QForm.vue?vue&type=template&id=26c2f946"
import script from "./QForm.vue?vue&type=script&lang=js"
export * from "./QForm.vue?vue&type=script&lang=js"
import style0 from "./QForm.vue?vue&type=style&index=0&id=26c2f946&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports